<template>
  <div class="bg">
    <!-- Snow Effect -->
    <div v-if="showSnow" class="snow-container">
      <div v-for="i in 30" :key="i" class="snowflake" :style="getSnowflakeStyle(i)">❄</div>
    </div>

    <!-- Snow Toggle Button -->


    <div class="wrapper fadeInDown">
      <div id="formContent">
        <!-- Snow Pile Effect -->
        <div v-if="showSnow" class="snow-pile"></div>

        <!-- Login Form -->
        <p v-if="incorrectAuth">{{ this.incorrectAuthmessage }}</p>
        <p>
          <img src="/static/media/miandum-logo.png" height="30" class="d-inline-block" alt />
        </p>
        <div v-if="changing_server">
          <form v-on:keyup.enter="change_server">
            <el-input v-model="server_url" placeholder="Enter server address" clearable />
            <el-button type="primary" plain @click="changing_server = false">Cancel</el-button>
            <el-button type="primary" plain @click="change_server">Set</el-button>
          </form>
        </div>
        <div v-else>
          <form v-on:keyup.enter="login">
            <el-input v-model="username" placeholder="Please input username" clearable />
            <el-input v-model="password" placeholder="Please input password" show-password />
            <el-button type="info" plain @click="changing_server = true" size="small">Change server</el-button>
            <el-button type="primary" plain @click="login">Log In</el-button>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { messages } from "@/popups";
import { inject, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue3-i18n';
import { useStore } from "vuex";
export default {
  name: "Login",
  components: {},
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const I18n = useI18n()
    let username = ref("")
    let password = ref("")
    let server_url = ref(store.state.auth.host)
    let changing_server = ref(false)
    let incorrectAuth = ref(false)
    let incorrectAuthmessage = ref("")
    const { ws_open } = inject("ws_connection")

    // Snow effect state - default to true (enabled)
    const showSnow = ref(false)

    const getSnowflakeStyle = (index) => {
      const random = (min, max) => Math.random() * (max - min) + min
      return {
        left: `${random(0, 100)}%`,
        animationDuration: `${random(10, 30)}s`,
        animationDelay: `${random(0, 10)}s`,
        fontSize: `${random(10, 25)}px`,
        opacity: random(0.3, 0.9)
      }
    }

    const change_server = () => {
      // alert(server_url.value)
      store.commit("auth/set_host", server_url.value)
      store.dispatch("auth/set_root_host")
      changing_server.value = false
    }

    const login = () => {
      if (username.value == "" || password.value == "") {
        incorrectAuthmessage.value = "Username and password must be provided!";
        incorrectAuth.value = true;
      } else {

        incorrectAuthmessage.value = "";
        incorrectAuth.value = false;
        store
          .dispatch("auth/userLogin", {
            username: username.value,
            password: password.value,
          })
          .then(() => {
            I18n.setLocale(store.state.ui.locale);
            ws_open()
            router.push(route.query.redirect || "/");
          })
          .catch((err) => {
            const { showerorr } = messages()
            showerorr(err);
            incorrectAuth.value = true;
          });
      }
    }


    return {
      username, password, incorrectAuth, incorrectAuthmessage, login, changing_server, change_server, server_url,
      showSnow, getSnowflakeStyle
    }
  },
};
</script>

<style scoped>
/* STRUCTURE */
.bg {
  background-image: url("/static/media/bg.jpg");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 90%;
  min-height: 100%;
  padding: 20px;
  opacity: 0.9;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #f6f2ef;
  padding: 20px;
  width: 95%;
  max-width: 450px;
  position: relative;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formContent .el-input {
  margin-top: 5px;
  margin-bottom: 5px;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* SNOW EFFECT */
.snow-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
  overflow: hidden;
}

.snowflake {
  position: absolute;
  top: -50px;
  color: white;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  animation: fall linear infinite;
  user-select: none;
}

@keyframes fall {
  0% {
    top: -50px;
    transform: translateX(0) rotate(0deg);
  }

  100% {
    top: 100vh;
    transform: translateX(100px) rotate(360deg);
  }
}

/* SNOW TOGGLE BUTTON */
.snow-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.snow-toggle:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.snow-toggle:active {
  transform: scale(0.95);
}

/* SNOW PILE ON FORM */
.snow-pile {
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to bottom,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(240, 248, 255, 0.9) 50%,
      transparent 100%);
  clip-path: polygon(0% 60%,
      8% 45%,
      15% 55%,
      22% 40%,
      30% 50%,
      38% 35%,
      45% 48%,
      52% 38%,
      60% 52%,
      68% 42%,
      75% 55%,
      82% 45%,
      90% 58%,
      95% 65%,
      98% 75%,
      100% 85%,
      100% 100%,
      0% 100%);
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.15));
  pointer-events: none;
  z-index: 10;
}

.snow-pile::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 15%;
  width: 25%;
  height: 20px;
  background: radial-gradient(ellipse at center,
      rgba(255, 255, 255, 0.9) 0%,
      transparent 70%);
  border-radius: 50%;
  filter: blur(2px);
}

.snow-pile::after {
  content: '';
  position: absolute;
  top: 10px;
  right: 20%;
  width: 30%;
  height: 18px;
  background: radial-gradient(ellipse at center,
      rgba(255, 255, 255, 0.85) 0%,
      transparent 65%);
  border-radius: 50%;
  filter: blur(2px);
}
</style>